import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_TERRITORY_FOR_TABLE_LOG: TDatadogErrorLog = {
  from: 'src/modules/territory/common/hooks/useNicheWithContext',
  name: 'Get territory for niche table',
  message: 'Fetch one territory to populate the Niche table',
}
